export enum SupportedChainId {
  BSC_TESTNET = 97,
  BSC = 56,
  FUJI = 43113,
  AVAX = 43114
}
